<template>
  <div class="drag-group-sentence-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <template
      v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questionData.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div class="drag-group-sentence-question-info-view" :style="showanswertype?'background:#fff':''">
      <div class="drag-drag-group-sentence-question-content-info-view1">
        <div style="width: 90%; height: 90%; display: flex; justify-content: space-around;flex-wrap: wrap"
             v-if="!showanswertype">
          <div class="drag-group-un-item" v-for="(option,index) in questioninfo.options">
            <draggable
              :options="{group:{name: flags,pull:'clone',put:false},filter: '.undraggable', sort: false,dragClass:'drag-view'}"
              @end="enddrag"
            >
              <div class="drag-group-sentence-drag1Area-item" :id="'drag'+index"
                   :data-index="index" @click="clickThis($event)">
                {{option.content}}
              </div>
            </draggable>
          </div>
        </div>
        <div class="drag-drop-sentence-content-view">
          <draggable :list="questioninfo.useroption.list"
                     :options="{group:{name: questioninfo.useroption.flags},filter: '.group-sentence-item',sort: false}"
                     class="drag-group-sentence-content" v-if="questioninfo.useroption">
          </draggable>
          <div class="clearbtn" v-if="showclear" @click="clearlist"></div>
          <!--<div class="right-sentence-answer-text" v-if="showanswertype">{{questioninfo.answer}}</div>-->
        </div>
        <div class="right-sentence-answer-btn" v-if="showanswertype" @click="playsentenceanswer"></div>
      </div>

    </div>
    <audio ref="groupsentencemusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
    <!--<div class="drag-group-sentent-bottom-view">-->
    <!--<button class="group-sentence-finish-btn" :class="isCanClick?'':'disable-btn'" @click="checkanswer"-->
    <!--v-if="!showanswertype">-->
    <!--{{$t("act.submit")}}-->
    <!--</button>-->
    <!--</div>-->
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';
  import draggable from 'vuedraggable'

  export default {
    name: "draggroupsentencequestion",
    components: {draggable},
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        disabled: false,
        flags: "article",
        showclear: false,
        audiourl: "",
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.groupsentencemusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData)
        if (this.questioninfo.useroption.list.length > 0) {
          setTimeout(() => {
            this.addDiv()
          }, 500)

        }
      },
      addDiv() {
        var dom = document.getElementsByClassName("drag-group-sentence-content")
        var doms = document.getElementsByClassName("drag-group-sentence-drag1Area-item")
        this.questioninfo.useroption.list.forEach((item, index) => {
          var div = document.createElement("div");
          div.setAttribute('data-index', index);
          div.setAttribute('id', "drag" + index);
          div.setAttribute('class', "group-sentence-item");
          div.setAttribute('draggable', false);  //设置文本为只读类型
          div.innerText = item
          dom[0].appendChild(div);
          for (var i = 0; i < doms.length; i++) {
            var ditem = doms[i];
            if (ditem.innerText == item) {
              this.addClass(ditem, "undraggable")
            }
          }

        })

      },
      paraseData(questionData) {
        var that = this;
        var questiondata = {};
        if (!questionData.useroption) {
          questiondata = JSON.parse(JSON.stringify(questionData))
          var content = questiondata.content;
          var contents = content.split("|");
          var options = []
          questiondata.contents = []
          questiondata.useroption = []
          questiondata.img = questiondata.content_img;
          contents.forEach(item => {
            options.push({content: item, list: [], flags: "article"})
          })
          questiondata.useroption = {
            answer: questiondata.answer,
            list: [],
            flags: "article"
          }
          questiondata.options = that.randomSort(options);
        } else {
          questiondata = JSON.parse(JSON.stringify(questionData))
          var content = questionData.content;
          var contents = content.split("|");
          var options = []
          contents.forEach(item => {
            options.push({content: item, list: [], flags: "article"})
          })

          questiondata.options = that.randomSort(options);
          this.showclear = true;
        }
        return questiondata;
      },
      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      enddrag(ev) {
        let _this = this;
        if (ev.to.className === "drag-group-sentence-content") {
          this.questioninfo.options[ev.clone.dataset.index].flags = ev.clone.dataset.index
          var dom = document.getElementById("drag" + ev.clone.dataset.index);
          this.addClass(dom, "undraggable")
          this.showclear = true;
          this.isCanClick = true;
          this.questioninfo.useroption.list.splice(ev.newIndex, 0, ev.clone.innerText.trim())
          var arr = document.getElementsByClassName("drag-group-sentence-content")[0].childNodes
          arr[0].innerText = _this.titleCase(arr[0].innerText.trim())
          var groups = document.getElementsByClassName("drag-group-sentence-content")
          for (var i = 0; i < groups[0].childNodes.length; i++) {
            var childitem = groups[0].childNodes[i];
            if (this.hasClass(childitem, "drag-group-sentence-drag1Area-item")) {
              this.removeClass(childitem, "drag-group-sentence-drag1Area-item");
              if (ev.clone.innerText.trim().search(/[\,|\.|\:|\.\.\.|\;|\?|\!]/g) == -1) {
                _this.addClass(childitem, "group-sentence-item")
              }
            }
          }
        }
        this.checkanswer()
      },
      clickThis(ev) {
        let _this = this
        if (ev.currentTarget.className.indexOf("undraggable") == -1) {
          _this.questioninfo.options[ev.currentTarget.dataset.index].flags = ev.currentTarget.dataset.index
          var dom = document.getElementById("drag" + ev.currentTarget.dataset.index);
          _this.addClass(dom, "undraggable")
          _this.showclear = true;
          _this.isCanClick = true;
          _this.questioninfo.useroption.list.splice(_this.questioninfo.useroption.list.length, 0, ev.currentTarget.innerText.trim())
          var dom = document.getElementsByClassName("drag-group-sentence-content")
          var div = document.createElement("div");
          div.setAttribute('data-index', _this.questioninfo.useroption.list.length);
          div.setAttribute('id', "drag" + _this.questioninfo.useroption.list.length);
          div.setAttribute('class', "group-sentence-item");
          div.setAttribute('draggable', false);  //设置文本为只读类型
          div.innerText = ev.currentTarget.innerText.trim()
          dom[0].appendChild(div);
          var arr = document.getElementsByClassName("drag-group-sentence-content")[0].childNodes
          arr[0].innerText = _this.titleCase(arr[0].innerText.trim())
          var groups = document.getElementsByClassName("drag-group-sentence-content")
          for (var i = 0; i < groups[0].childNodes.length; i++) {
            var childitem = groups[0].childNodes[i];
            if (_this.hasClass(childitem, "drag-group-sentence-drag1Area-item")) {
              _this.removeClass(childitem, "drag-group-sentence-drag1Area-item");
              if (ev.currentTarget.innerText.trim().search(/[\,|\.|\:|\.\.\.|\;|\?|\!]/g) == -1) {
                _this.addClass(childitem, "group-sentence-item")
              }
            }
          }
        }
        this.checkanswer()
        this.$forceUpdate();
        ev.stopPropagation()
      },
      titleCase(str) {
        let strArr = str.split(' ');
        strArr[0] = strArr[0].substring(0, 1).toUpperCase() + strArr[0].toLowerCase().substring(1)
        return strArr.join(' ');
      },
      clearlist() {
        this.showclear = false;
        this.questioninfo.useroption.list = []
        var groups = document.getElementsByClassName("drag-group-sentence-content");
        groups[0].innerHTML = ""
        this.questioninfo.options.forEach((item, index) => {
          var dom = document.getElementById("drag" + index);
          if (this.hasClass(dom, "undraggable")) {
            this.removeClass(dom, "undraggable");
          }
          item.flags = "article"
        })

      },
      checkanswer() {
        this.questioninfo.isfinish = true;
        console.log(this.questioninfo)
        this.$emit("questionfinish", this.questioninfo)
      },
      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.groupsentencemusic.src = audiourl;
        if (this.$refs.groupsentencemusic.paused) {
          this.$refs.groupsentencemusic.play()
          this.contentplay = true;
        }
      },
      prev() {
        this.$refs.groupsentencemusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.groupsentencemusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .drag-group-sentence-question-view {
    width 100%;
    height 100%;
  }

  .drag-group-sentence-question-info-view {
    display flex;
    width 88.54%;
    height 100%;
    position relative;
    display flex;
    justify-content space-around;
    align-items center;
    left 5.73%;
    border-radius 12px;
  }

  .drag-drag-group-sentence-question-content-info-view1 {
    width 100%;
    height 100%;
    margin 10px auto;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
  }

  .drag-drag-group-sentence-question-content-info-view {
    width 30%;
    height 100%;
    margin 10px auto;
    display flex;
    flex-direction row;
    align-items center;
    justify-content space-around;
  }

  .group-sentence-item {
    margin-left 10px;
  }

  .undraggable {
    background: #F6C753 !important;
    border: 3px dashed rgba(189, 189, 189, 1);
    border-radius: 12px;
    color rgba(0, 0, 0, 0) !important;
  }

  .drag-group-sentence-drag1Area {
    display flex;
    align-items center;
    flex-wrap wrap;
    justify-content space-around;
  }

  .drag-group-un-item {
    height 400px;
  }

  .drag-group-sentence-drag1Area1 {
    width 100%;
    height 100%;
    display flex;
    align-items center;
    justify-content space-around;
  }

  .drag-group-sentence-drag1Area-item {
    font-size 42px;
    background #FF9A09;
    height 80px;
    margin 0 10px;
    padding 0 30px;
    border-radius 12px;
    display: flex;
    justify-content center;
    align-items center;
  }

  .drag-group-sentence-content {
    width 80%;
    min-height 42px;
    padding 0 50px;
    display flex;
    align-self center;
    justify-self center;
    position absolute;
    flex-wrap wrap;
    left 2%
    font-size 30px;
    margin 0 auto;
  }

  .drag-drop-sentence-content-view {
    width 100%;
    min-height 90px;
    position absolute;
    top: 34%;
    border-bottom 3px solid #131313;
  }

  .clearbtn {
    width 50px;
    height 50px;
    float right;
    margin-right 20px;
    background url("../../assets/img/clear-btn-icon.png")
    background-size 100% 100%;
    z-index 2000;
  }

  .drag-group-sentent-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;
  }

  .group-sentence-finish-btn {
    width 50%;
    height 72px;
    font-size 36px;
    position absolute;
    left 25%;
    bottom 30px;
    border-radius 36px;
    background #5777FF;
    color #fff;
  }

  .right-sentence-answer-text {
    font-size 72px;
    color #92C761;
    margin-top 100px;
  }

  .right-sentence-answer-btn {
    position absolute;
    bottom 5px;
    display flex;
    align-self center;
    background url("../../assets/img/showanswer-play-btn.png");
    background-size 100% 100%;
    width 100px;
    height 100px;
  }

  @media screen and (max-width: 1600px) {
    .drag-group-sentence-question-info-view {
      top -6%;
    }

    .drag-group-un-item {
      height 260px;
    }

    .drag-group-sentence-drag1Area-item {
      font-size 64px;
      background #FF9A09;
      height 100px;
      margin 0 10px;
      padding 0 30px;
      border-radius 12px;
      display: flex;
      justify-content center;
      align-items center;
    }

    .drag-group-sentent-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;
    }

    .group-sentence-finish-btn {
      width 50%;
      height 48px;
      font-size 24px;
      position absolute;
      left 25%;
      bottom 5px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }
  }

  @media screen and (max-width: 1366px) {
    .drag-group-sentence-question-info-view {
      display flex;
      width 88.54%;
      height 80%;
      background #F6C753;
      position relative;
      display flex;
      justify-content space-around;
      align-items center;
      left 5.73%;
      top -15%;
      border-radius 12px;
    }

    .drag-group-un-item {
      height 260px;
    }

    .drag-group-sentence-drag1Area-item {
      font-size 64px;
      background #FF9A09;
      height 100px;
      margin 0 10px;
      padding 0 30px;
      border-radius 12px;
      display: flex;
      justify-content center;
      align-items center;
    }

    .drag-group-sentent-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;
    }

    .group-sentence-finish-btn {
      width 50%;
      height 48px;
      font-size 24px;
      position absolute;
      left 25%;
      bottom 5px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/draggroupsentencequestion.vue